import { Answer, Api as AnswersApi } from '@legalshield/frontend-commons-fetch/answers';
import { SDKHeaders } from '@legalshield/frontend-commons-fetch/utils';

import { ReplaceAnswersError } from '../errors/ReplaceAnswers.error';

const userId = 'b6a1053b-fc01-4acc-9689-768609f4f2d9';

const answersApi = new AnswersApi();

const replaceAnswer = async (version: number, answerId: string, answer: Answer): Promise<Answer> => {
  const response = await answersApi.v1.publicAnswersReplaceAnswer(
    userId,
    answerId,
    answer,
    SDKHeaders.getVersionConfig(String(version)),
  );

  if (!response.ok) {
    throw new ReplaceAnswersError();
  }

  return response.data;
};

export default replaceAnswer;
